import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import comingSoon from "../images/coming_soon.svg";

/**
 * ComingSoon - Placeholder shown in place of a tab's content when the feature
 * is gated off for the current user (percentage rollout). The tab itself stays
 * visible; only the content is swapped.
 *
 * Renders the shared coming-soon illustration (coming_soon.svg) alongside the
 * "Coming soon" text, matching the image-based placeholder the Agenda tab
 * historically used so flag-off views stay visually consistent.
 */
const ComingSoon = ({ message = "Coming soon" }) => (
  <>
    <Row height="48px"/>
    <Row spacing="none">
      <Column width="13px"/>
      <img src={comingSoon} alt={message} />
    </Row>
    <Row spacing="none">
      <Column width="67px"/>
      <Column alignmentHorizontal="start" spacing="none" width="238px">
        <Row height="24px"/>
        <Text type="h50" alignment="center">{message}</Text>
      </Column>
    </Row>
  </>
);

export default ComingSoon;
